import type { TranslationExclusionValue } from '../../types';
import { elementsFinder } from './elements-finder';
import { elementsSetter } from './elements-setter';
import { textFinder } from './text-finder';
import { textSetter } from './text-setter';

export interface PhraseInfo {
  type: 'text' | 'attribute';
  node?: Node;
  element?: Element;
  attributeName?: string;
  phrase: string;
}

export function collectPhrases(
  element: Node | Element,
  translationExclusions: TranslationExclusionValue[]
): PhraseInfo[] {
  const phrases: PhraseInfo[] = [];

  const { textNodes, textPhrases } = textFinder(element, translationExclusions);
  textNodes.forEach((node, index) => {
    phrases.push({
      type: 'text',
      node,
      phrase: textPhrases[index]
    });
  });

  const { nodes: placeholderNodes, phrases: placeholderPhrases } =
    elementsFinder({
      element,
      querySelector: '[placeholder]',
      attributeName: 'placeholder',
      translationExclusions
    });
  placeholderNodes.forEach((node, index) => {
    phrases.push({
      type: 'attribute',
      element: node,
      attributeName: 'placeholder',
      phrase: placeholderPhrases[index]
    });
  });

  const { nodes: inputSubmitValueNodes, phrases: inputSubmitValuePhrases } =
    elementsFinder({
      element,
      querySelector: 'input[type="submit"]',
      attributeName: 'value',
      translationExclusions
    });
  inputSubmitValueNodes.forEach((node, index) => {
    phrases.push({
      type: 'attribute',
      element: node,
      attributeName: 'value',
      phrase: inputSubmitValuePhrases[index]
    });
  });

  return phrases;
}

export function updateDOM(
  phrasesInfo: PhraseInfo[],
  translatedPhrases: string[]
) {
  phrasesInfo.forEach((info, index) => {
    const translatedPhrase = translatedPhrases[index];

    if (info.phrase === translatedPhrase) {
      return;
    }

    if (info.type === 'text' && info.node) {
      textSetter([info.node], [translatedPhrase]);
    } else if (
      info.type === 'attribute' &&
      info.element &&
      info.attributeName
    ) {
      elementsSetter({
        nodes: [info.element],
        phrases: [translatedPhrase],
        attributeName: info.attributeName
      });
    }
  });
}
